export default "__VITE_ASSET__B3lqFCiO__"